import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/reporter';
import { updateCategoryAction, viewInTransactionAction, goToActivityRouteAction, removeBladeAction, downloadCheckAction, printCheckAction, toggleCancelPrintableCheckAction, cancelPrintableCheckRequestAction, recognizeTransactionRequestAction, listCategoriesAction, toggleCategoriesAction } from '@banking/ui/workflows/unified-activity/unified-activity';
export const template = hbs`
  <Banking::Activity::Blade
    ...attributes
    @activityId={{this.activityId}}
    @attachments={{this.attachments}}
    @loadingDetails={{this.loadingDetails}}
    @hasBladeError={{this.hasBladeError}}
    @formattedDetail={{this.formattedDetail}}
    @stateCategory={{this.stateCategory}}
    @detailsFooter={{this.detailsFooter}}
    @title={{this.title}}
    @image={{this.image}}
    @svgName={{this.svgName}}
    @svgModifierClass={{this.svgModifierClass}}
    @amount={{this.amount}}
    @isDisputable={{this.isDisputable}}
    @isVoided={{this.isVoided}}
    @pillDetail={{this.pillDetail}}
    @detailsButtonAction={{this.detailsButtonAction}}
    @banner={{this.banner}}
    @description={{this.description}}
    @lineItems={{this.lineItems}}
    @authenticationNeeded={{this.authenticationNeeded}}
    @transactionAuthState={{this.transactionAuthState}}
    @onRecognizeTransaction={{this.onRecognizeTransaction}}
    @unitToken={{this.unitToken}}
    @closeAction={{this.closeAction}}
    @onViewInTransaction={{this.onViewInTransaction}}
    @onUpdateCategory={{this.onUpdateCategory}}
    @listCategories={{this.listCategories}}
    @onCloseBlade={{this.onCloseBlade}}
    @onDestroyBlade={{this.onDestroyBlade}}
    @printableCheckManagement={{this.printableCheckManagement}}
    @onPrintCheck={{this.onPrintCheck}}
    @onDownloadCheck={{this.onDownloadCheck}}
    @onToggleCancelCheck={{this.onToggleCancelCheck}}
    @showCategories={{this.showCategories}}
    @toggleCategories={{this.toggleCategories}}
    @listCategoriesResponse={{this.listCategoriesResponse}}
    @selectedCategoryId={{this.selectedCategoryId}}
    @findataTransactionId={{this.findataTransactionId}}
  />

  {{#if this.showCancelPrintableCheckDialog}}
    <Banking::Activity::PrintableCheckCancelDialog
      ...attributes
      @errorState={{this.cancelPrintableCheckError}}
      @isCancelPrintableCheckLoading={{this.isCancelPrintableCheckLoading}}
      @onCancelCheck={{this.onCancelCheck}}
      @onDismiss={{this.onToggleCancelCheck}}
      @warningDialog={{this.printableCheckManagement.cancelAction.warningDialog}}
    />
  {{/if}}
`;
export const mapStateToProps = (state, ownArgs) => {
  const {
    loadingDetails,
    hasBladeError,
    formattedDetail,
    printableCheckManagement,
    showCancelPrintableCheckDialog,
    isCancelPrintableCheckLoading,
    cancelPrintableCheckError,
    showCategories,
    listCategoriesResponse
  } = state;
  const {
    id,
    attachments,
    stateCategory,
    detailsFooter,
    title,
    image,
    svgName,
    svgModifierClass,
    amount,
    isDisputable,
    isVoided,
    pillDetail,
    detailsButtonAction,
    banner,
    description,
    lineItems,
    authenticationNeeded,
    transactionAuthState,
    findataTransactionInfo
  } = formattedDetail;
  let selectedCategoryId;
  lineItems.forEach(lineItem => {
    if ('categoryData' in lineItem) {
      selectedCategoryId = lineItem.categoryData?.categoryId;
    }
  });
  return {
    activityId: id,
    attachments,
    loadingDetails,
    hasBladeError,
    formattedDetail,
    stateCategory,
    detailsFooter,
    title,
    image,
    svgName,
    svgModifierClass,
    amount,
    isDisputable,
    isVoided,
    pillDetail,
    detailsButtonAction,
    banner,
    description,
    lineItems,
    authenticationNeeded,
    transactionAuthState,
    findataTransactionId: findataTransactionInfo?.findataTransactionId,
    unitToken: ownArgs.unitToken,
    closeAction: ownArgs.closeAction,
    printableCheckManagement,
    showCancelPrintableCheckDialog,
    isCancelPrintableCheckLoading,
    cancelPrintableCheckError,
    showCategories,
    listCategoriesResponse,
    selectedCategoryId
  };
};
export const mapActionsToProps = () => ({
  onViewInTransaction: detailsButtonAction => {
    if (detailsButtonAction && detailsButtonAction.queryParams) {
      return viewInTransactionAction(detailsButtonAction.queryParams);
    }
    return goToActivityRouteAction();
  },
  onUpdateCategory: updateCategoryAction,
  listCategories: listCategoriesAction,
  onCloseBlade: action => action,
  onDestroyBlade: () => removeBladeAction(),
  onDownloadCheck: printableCheckId => downloadCheckAction(printableCheckId),
  onPrintCheck: printableCheckId => printCheckAction(printableCheckId),
  onCancelCheck: () => cancelPrintableCheckRequestAction(),
  onToggleCancelCheck: () => toggleCancelPrintableCheckAction(),
  onRecognizeTransaction: isRecognized => recognizeTransactionRequestAction(isRecognized),
  toggleCategories: toggleCategoriesAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);